import Alpine from "alpinejs";

Alpine.magic("isMobileDevice", () => () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
});
